const React = require('react');
const Swipe = require('../../Swipe');

class SectionSlideshow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected:    0,
            iframeAspectRatios: {},
        };
        this.iframeContainerRefs = {};
        this.iframeRefs = {};
        this.resizeIframe = this.resizeIframe.bind(this);
    }
    resizeIframe() {
        const SAFETY_MARGIN = 10;
        Object.keys(this.iframeContainerRefs).forEach((index) => {
            const iframeContainer = this.iframeContainerRefs[index];
            const iframe = this.iframeRefs[index];
            if (iframeContainer && iframe) {
                const containerWidth = iframeContainer.offsetWidth;
                const containerHeight = iframeContainer.offsetHeight;
                const containerAspectRatio = containerWidth / containerHeight;
                const iframeAspectRatio = this.state.iframeAspectRatios[index];
    
                let newWidth, newHeight;
    
                if (iframeAspectRatio > containerAspectRatio) {
                    // If iframe is wider than container, adjust height
                    newHeight = containerHeight + SAFETY_MARGIN;
                    newWidth = newHeight * iframeAspectRatio;
                } else {
                    // If iframe is taller than container, adjust width
                    newWidth = containerWidth + SAFETY_MARGIN;
                    newHeight = newWidth / iframeAspectRatio;
                }
    
                // Apply new dimensions
                iframe.style.width = `${newWidth}px`;
                iframe.style.height = `${newHeight}px`;
    
                // Center the iframe in the container
                iframe.style.position = 'absolute';
                iframe.style.left = `50%`;
                iframe.style.top = `50%`;
                iframe.style.transform = `translate(-50%, -50%)`;
            }
        });
    }
    
    componentDidMount() {
        this.calculateIframeAspectRatios();
        setTimeout(() => this.resizeIframe(), 200);
        window.addEventListener('resize', this.resizeIframe);
    }
    calculateIframeAspectRatios() {
        const { slides } = this.props;
        const iframeAspectRatios = {};

        slides.forEach((slide, index) => {
            if (slide.media.type === 'vimeo') {
                iframeAspectRatios[index] = slide.media.width / slide.media.height;
            }
        });

        this.setState({ iframeAspectRatios });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeIframe);
    }
    render() {
        const {slides} = this.props;
        const {selected} = this.state;
        return (
        <section className="section-slideshow" ref="slideshow">
            <Swipe options={{loop: false, centeredSlides: true, slidesPerView: 'auto'}} pagination={false}>
                {slides.map((slide, index) => {
                    return (
                    <div key={index} className="section-slideshow__slide">
                        <div className="section-slideshow__content-container">
                            {slide.title && <h2 className="section-slideshow__title">{slide.title}</h2>}
                            <p className="section-slideshow__description">{slide.description}</p>
                            {slide.link && <a href={slide.link} className="section-slideshow__link">Les mer</a>}
                        </div>
                        {slide.media.type === 'image' && (
                            <div className="section-slideshow__image-container" style={{backgroundImage: `url(${slide.media.image})`}}>
                                <img src={slide.media.image} />
                            </div>
                        )}
                        {slide.media.type === 'vimeo' && (
                            <div className="section-slideshow__iframe-container" ref={(el) => this.iframeContainerRefs[index] = el}>
                                <iframe ref={(el) => this.iframeRefs[index] = el} src={`https://player.vimeo.com/video/${slide.media.id}?controls=0&muted=1&background=1`} style={{ width: slide.media.width, height: slide.media.height }} frameborder="0" allow="autoplay"></iframe>
                            </div>
                        )}
                    </div>
                    )
                })}
            </Swipe>
            {slides && slides.length > 1 && (
            <div className="section-slideshow__dots">
                {slides.map((slide, i) => {
                    const isSelected = i === selected;
                    return (
                    <button key={i} className={['section-slideshow__dot', isSelected ? 'section-slideshow__dot--selected' : ''].join(' ')} onClick={() => this.refs.swipe.slide(i)} disabled={isSelected}/>
                    );
                })}
            </div>
            )}
        </section>
        )
    }
}

module.exports = SectionSlideshow;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/section-slideshow/Component/index.jsx